// Components
import registerAnnotation from '../../../../common/drawings/annotations/index';
import presentationalComponent from './Annotation';
import containerComponent from './AnnotationContainer';

// Constants
import { TOOLS } from '../../../workspace/toolbar/toolbarConstants';
import { TOOLBAR_TOOLS } from '../../../workspace/toolbarV2/config/toolbarToolConfig';

export default () =>
    registerAnnotation({
        presentationalComponent,
        containerComponent,
        tools: [TOOLS.EDIT_DRAWING],
        selectedTools: [TOOLBAR_TOOLS.EDIT_DRAWING],
    });
